import React from 'react';
import { Divider } from 'rc-menu';
import { DropdownComponentProps } from './types';

export const DropdownDivider: React.FC<DropdownComponentProps> = (props) => (
  <Divider {...props} />
);

DropdownDivider.displayName = 'DropdownDivider';
